import { create } from "zustand";
import produce from "immer";
import { persist } from "zustand/middleware";

let store = (set) => ({
    selectedVehicles: [],
    setSelectedVehicles: (vehicles) =>
        set(
            produce((state) => {
                state.selectedVehicles = vehicles;
            })
        ),
    toggleVehicle: (vehicleId) =>
        set(
            produce((state) => {
                if (state.selectedVehicles.includes(vehicleId)) {
                    state.selectedVehicles = state.selectedVehicles.filter(id => id !== vehicleId);
                } else {
                    state.selectedVehicles.push(vehicleId);
                }
            })
        ),
    clearSelectedVehicles: () =>
        set(
            produce((state) => {
                state.selectedVehicles = [];
            })
        ),
});

store = persist(store, { name: "selectedVehicles" });
export const useSelectedVehicles = create(store);
